const getApiErrorMessage = (error: any): string => {
  const isText = (text: any): boolean => typeof text === 'string' && !!text.length;
  if (isText(error)) return error;
  if (isText(error?.message)) return error.message;
  return 'Unknown error';
};

export default getApiErrorMessage;
